export default {
    'editor': {
        'heading_1': 'Naslov 1',
        'heading_2': 'Naslov 2',
        'heading_3': 'Naslov 3',
        'paragraph': 'Odlomak',
        'bold': 'Podebljano',
        'italic': 'Kurziv',
        'underline': 'Podcrtano',
        'ordered_list': 'Numerirani popis',
        'bullet_list': 'Označeni popis',
        'align_left': 'Poravnaj lijevo',
        'align_center': 'Poravnaj na sredinu',
        'align_right': 'Poravnaj desno',
        'align_justify': 'Obostrano',
        'link': 'Poveznica',
        'color': 'Boja teksta',
        'image': 'Slika',
        'divider': 'Razdjelnik'
    },
    'colors': {
        'red': 'Crvena',
        'orange': 'Narančasta',
        'yellow': 'Žuta',
        'green': 'Zelena',
        'blue': 'Plava',
        'purple': 'Ljubičasta',
        'pink': 'Roza',
        'gray': 'Siva'
    },
    'general': {
        'administration': 'Administracija',
        'dashboard': 'Nadzorna ploča',
        'email': 'E-pošta',
        'phone': 'Telefon',
        'username': 'Korisničko ime',
        'name': 'Ime',
        'password': 'Lozinka',
        'value': 'Vrijednost',
        'actions': 'Akcije',
        'login': 'Prijava',
        'logout': 'Odjava',
        'no_results': 'Nema rezultata',
        'success': 'Uspjeh',
        'warning': 'Upozorenje',
        'remember_me': 'Zapamti me',
        'error': 'Greška',
        'edit': 'Uredi',
        'details': 'Detalji',
        'add': 'Dodaj',
        'delete': 'Izbriši',
        'yes': 'Da',
        'no': 'Ne',
        'cancel': 'Odustani',
        'back': 'Natrag',
        'image': 'Slika',
        'filters': 'Filteri',
        'remove_filters': 'Ukloni filtere',
        'default': 'Zadano',
        'save': 'Spremi',
        'preview': 'Pregled',
        'icon': 'Ikona',
        'change': 'Promijeni',
        'unlimited': 'Neograničeno',
        'active': 'Aktivno',
        'all': 'Sve',
        'from': 'Od',
        'to': 'Do',
        'date': 'Datum',
        'custom': 'Prilagođeno',
        'country': 'Država',
        'total': 'Ukupno',
        'basic_data': 'Osnovni podaci',
        'show_more': 'Prikaži više',
        'export_data': 'Izvezi podatke',
        'approve': 'Odobri',
        'reject': 'Odbij',
        'generate': 'Generiraj',
        'check': 'Provjeri',
        'file_type': 'Vrsta datoteke',
        'size': 'Veličina',
        'text': 'Tekst',
        'title': 'Naslov',
        'address': 'Adresa',
        'zip': 'Poštanski broj',
        'city': 'Grad',
        'created': 'Kreirano',
        'drag_and_drop_files_to_upload': 'Povucite i ispustite datoteke za učitavanje',
        'file_missing': 'Datoteka ne postoji',
        'upload_failed': 'Prijenos nije uspio',
        'retry_upload': 'Pokušaj ponovno',
        'delete_all': 'Izbriši sve',
        'left': 'Ljevo',
        'right': 'Desno',
        'top': 'Gore',
        'bottom': 'Dole',
        'settings': 'Postavke',
        'instructions': 'Upute',
        'instructions_admin_portal': 'Upute za administracijski portal',
        'instructions_website_images': 'Upute za slike na web stranici',
        'open': 'Otvori',
        'download': 'Preuzmi',
        'guarantee_specification': 'Specifikacija jamstva'
    },
    'errors': {
        'generic_error': 'Došlo je do greške',
        'login': 'Došlo je do greške prilikom prijave',
        'logout': 'Došlo je do greške prilikom odjave',
        'incorrect_password': 'Stara lozinka je netočna',
        'invalid_data': 'Primljeni su nevažeći podaci',
        'not_found': 'Podaci nisu pronađeni',
        'user_exist': 'Korisnik s ovom e-poštom već postoji',
        'load_data': 'Došlo je do greške prilikom učitavanja podataka',
        'on_upload_file': 'Došlo je do greške prilikom prijenosa datoteka',
        'on_export_file': 'Došlo je do greške prilikom izvoza datoteke',
        'on_import_file': 'Došlo je do greške prilikom uvoza datoteke',
        'on_add': 'Došlo je do greške prilikom dodavanja',
        'on_edit': 'Došlo je do greške prilikom uređivanja',
        'on_delete': 'Došlo je do greške prilikom brisanja',
        'on_sort': 'Došlo je do pogreške prilikom sortiranja',
        'unauthorized': 'Neautorizirano',
        'user_does_not_exist': 'Korisnik ne postoji',
        'failed_to_insert': 'Umetanje nije uspjelo',
        'file_to_big': 'Datoteka je prevelika',
        'file_type_not_allowed': 'Vrsta datoteke nije dozvoljena',
        'unable_to_retrieve_extension': 'Nije moguće dohvatiti ekstenziju',
        'no_access': 'Nema pristupa',
        'field_name_exists': 'Naziv polja već postoji',
        'category_exists': 'Kategorija s jednim od unesenih naziva već postoji',
        'product_brand_exists': 'Brand proizvoda s istim imenom već postoji',
        'sale_partner_exists': 'Partner za prodajo s istim imenom već postoji',
        'additional_page_exists': 'Dodatna straica s unesenim nazivom već postoji',
        'invalid_order_status': 'Nevažeći status narudžbe',
        'product_exists': 'Proizvod s SKU i zemljom već postoji',
        'product_slug_exists': 'Proizvod s istim imenom za SKU i zemlju već postoji',
        'unknown_type': 'Nepoznata vrsta',
        'price_list_for_selected_partner_is_empty': 'Cjenik za odabranog partnera je prazan',
        'product_title_required': 'Naziv proizvoda je obavezan',
        'product_country_required': 'Država proizvoda je obavezna',
        'product_vat_group_required': 'PDV grupa proizvoda je obavezna',
        'product_price_invalid': 'Cijena proizvoda ne smije biti negativna',
        'product_discount_invalid': 'Popust proizvoda mora biti između 0 i 100',
        'product_stock_invalid': 'Zaliha proizvoda ne smije biti negativna',
        'vat_group_not_found_for_country': 'PDV grupa ne postoji za odabranu državu',
        'category_not_found': 'Kategorija ne postoji',
        'sale_website_not_found': 'Prodajna stranica ne postoji',
        'product_brand_not_found': 'Robna marka ne postoji',
        'specification_not_found': 'Specifikacija proizvoda ne postoji',
        'invalid_field_value': 'Neispravna vrijednost u polju',
        'sale_website_type_exists': 'Web stranica s odabranom vrstom već postoji',
        'discount_coupon_code_invalid': 'Kod mora imati od 3 do 50 znakova: A-Z, 0-9, - i _',
        'discount_coupon_invalid_type': 'Nepoznat tip popusta',
        'discount_coupon_value_invalid': 'Vrijednost popusta mora biti između 0 i 100',
        'discount_coupon_validity_invalid': 'Datum „vrijedi od“ mora biti prije datuma „vrijedi do“',
        'discount_coupon_code_exists': 'Kod za popust s ovim kodom već postoji',
        'discount_coupon_country_invalid': 'Nevažeća država na kodu za popust',
        'product_warranty_invalid': 'Garancija ne smije biti negativna i mora imati jedinicu'
    },
    'success': {
        'on_add': 'Uspješno dodano',
        'on_edit': 'Uspješno uređeno',
        'on_delete': 'Uspješno izbrisano',
        'on_sort': 'Uspješno sortirano'
    },
    'confirmations': {
        'general': 'Jeste li sigurni da želite nastaviti?',
        'header': 'Jeste li sigurni',
        'delete_row': 'Jeste li sigurni da želite izbrisati',
        'delete_all': 'Jeste li sigurni da želite izbrisati sve?',
        'unsaved_changes': 'Nespremljene promjene',
        'unsaved_changes_info': 'Jeste li sigurni da želite napustiti ovu stranicu? Sve vaše izmjene će biti izgubljene.',
        'disable_product': 'Jeste li sigurni da želite onemogućiti produkt {title}? Produkt će biti uklonjen s web stranica, cjenika i tražilice.',
        'enable_product': 'Jeste li sigurni da želite ponovno omogućiti produkt {title}? Produkt će dobiti status Nije objavljeno.'
    },
    'table': {
        'no_data': 'Nema podataka za prikaz',
        'press_enter_search': 'Pritisnite enter za pretraživanje',
        'search': 'Pretraživanje po',
        'select_option': 'Odaberite opciju',
        'select_date': 'Odaberite datum',
        'select_range': 'Odaberite raspon',
        'of': 'od'
    },
    'profile': {
        'profile': 'Profil',
        'edit_profile': 'Uredi profil',
        'old_password': 'Stara lozinka',
        'new_password': 'Nova lozinka',
        'confirm_password': 'Potvrdi lozinku',
        'change_password': 'Promijeni lozinku'
    },
    'language': {
        'slovenian': 'Slovenski',
        'english': 'Engleski',
        'croatian': 'Hrvatski'
    },
    'country_sale': {
        'slovenia': 'Slovenija',
        'croatia': 'Hrvatska',
        'serbia': 'Srbija',
        'austria': 'Austrija'
    },
    'user': {
        'user': 'Korisnik | Korisnici',
        'add': 'Dodaj korisnika',
        'edit': 'Uredi korisnika',
        'firstname': 'Ime',
        'lastname': 'Prezime',
        'email': 'E-pošta',
        'language': 'Jezik',
        'password': 'Lozinka',
        'cannot_edit_email': 'E-poštu nije moguće urediti'
    },
    'vat_group': {
        'vat_group': 'PDV grupa | PDV grupe',
        'add': 'Dodaj PDV grupu',
        'edit': 'Uredi PDV grupu',
        'country': 'Država',
        'prices_not_recalculated': 'Promjena PDV grupe ne mijenja cijene proizvoda koji koriste tu PDV grupu. Cijene je po potrebi potrebno ručno ispraviti.'
    },
    'discount_coupon': {
        'discount_coupon': 'Kod za popust | Kodovi za popust',
        'add': 'Dodaj kod za popust',
        'edit': 'Uredi kod za popust',
        'code': 'Kod',
        'type': 'Tip popusta',
        'type_percentage': 'Postotak',
        'valid_from': 'Vrijedi od',
        'valid_to': 'Vrijedi do',
        'validity': 'Valjanost',
        'validity_hint': 'Prazan datum znači bez ograničenja.',
        'scope': 'Gdje vrijedi',
        'scope_hint': 'Prazan popis znači bez ograničenja. Svaki ispunjen popis je uvjet: proizvod mora istodobno odgovarati odabranoj kategoriji, marki i proizvodu. Unutar pojedinog popisa dovoljan je bilo koji unos.',
        'selected_products': 'Odabrani proizvodi',
        'select_products': 'Odaberi proizvode',
        'no_selected_products': 'Nema odabranih proizvoda',
        'generate_code': 'Generiraj kod',
        'applied_to_item': 'Za ovu stavku je primijenjen kod za popust',
        'countries': 'Države',
        'countries_hint': 'Dostupne su države odabranih web stranica.'
    },
    'product_specification': {
        'product_specification': 'Specifikacija proizvoda | Specifikacije proizvoda',
        'add': 'Dodaj specifikaciju proizvoda',
        'edit': 'Uredi specifikaciju proizvoda',
        'field_name': 'Naziv polja',
        'field_name_info': 'Preporučuje se da se naziv polja napiše na engleskom. Primjeri: load_capacity, height, weight.',
        'field_name_exists': 'Naziv polja već postoji',
        'required_specification': 'Obvezna specifikacija',
        'predefined_values': 'Unaprijed definirane vrijednosti',
        'value': 'Vrijednost',
        'add_new_value': 'Dodaj novu vrijednost',
        'position': 'Pozicija'
    },
    'required_category_specification': {
        'required_category_specification': 'Obvezna specifikacija kategorije | Obvezne specifikacije kategorij',
        'add': 'Dodaj obvezne specifikacije kategorije',
        'edit': 'Uredi obvezne specifikacije kategorije'
    },
    'sale_website': {
        'sale_website': 'Web stranica | Web stranice',
        'add': 'Dodaj web stranico',
        'edit': 'Uredi web stranico',
        'type': 'Vrsta stranice',
        'countries': 'Zemlje',
        'color': 'Boja',
        'button_text': 'Tekst gumba',
        'button_type': 'Vrsta gumba',
        'link': 'Link',
        'button': 'Gumb | Gumbi',
        'no_buttons_defined': 'Nema definiranih gumba',
        'image_position': 'Pozicija slike',
        'image_on_right': 'Slika desno',
        'full_width_image': 'Slika pune širine',
        'show_background': 'Prikaži pozadinu',
        'show_as_slider': 'prikaži kao klizač',
        'is_video': 'Je video',
        'general_info': 'Opće informacije',
        'home_page': 'Početna stranica',
        'save_home_page': 'Shrani početno stranico',
        'additional_product_pages': 'Dodatne stranice proizvoda',
        'primary_specification_filters': 'Primarni filteri specifikacija',
        'service': 'Servis',
        'about_us': 'O nama',
        'terms_and_conditions': 'Uvjeti poslovanja',
        'privacy_policy': 'Politika privatnosti',
        'company_presentation': 'Predstavljanje tvrtke',
        'custom_solutions': 'Rješenja po mjeri',
        'representation': 'Zastupstvo',
        'customer_support': 'Korisnička podrška',
        'delivery': 'Dostava',
        'payment_methods': 'Načini plaćanja',
        'top_nav_banner': 'Gornji navigacijski banner',
        'social_media': 'Društveni mediji',
        'service_information': 'Informacije o servisu',
        'contact': 'Kontakt',
        'active': 'Aktivan',
        'show_in_top_navigation': 'Prikaži u gornjoj navigaciji',
        'show_in_bottom_navigation': 'Prikaži u donjoj navigaciji',
        'page': 'Stranica',
        'internal_page': 'Interna stranica',
        'external': 'Vanjska poveznica',
        'download_attachment': 'Preuzmi privitak',
        'add_to_cart': 'Dodaj u košaricu',
        'component': 'Kompoenta | Komponente',
        'configuration': 'Konfiguracija',
        'select_custom': 'Odaberite prilagođeno',
        'content': 'Sadržaj',
        'invalid_page_content_button_values': 'Odabrane vrijednosti na stranicama koje sadrže gumbe nisu ispravne. Molimo provjerite sve komponente s gumbima.',
        'invalid_buttons': 'Gumbi koji ne vode nikamo',
        'invalid_buttons_info': 'Ti gumbi pokazuju na proizvod ili stranicu koja više ne postoji. Otvorite mjesto na kojem je gumb spremljen i ispravite ga ili ga uklonite.',
        'invalid_button_place': 'Mjesto',
        'invalid_button_reason_header': 'Razlog',
        'invalid_button_component_position': 'komponenta {index}',
        'invalid_button_item_position': 'stavka {index}',
        'invalid_button_button_position': 'gumb {index}',
        'invalid_button_location': {
            'top_nav_banner': 'Baner u gornjoj navigaciji',
            'home_page': 'Početna stranica',
            'additional_page': 'Dodatna stranica'
        },
        'invalid_button_reason': {
            'product_not_found': 'Proizvod s ovom poveznicom ne postoji',
            'additional_page_not_found': 'Dodatna stranica s ovom poveznicom ne postoji',
            'component_data_unreadable': 'Podatke komponente nije moguće pročitati'
        },
        'no_components': 'Ova stranica još ne sadrži komponente',
        'no_components_info': 'Komponentu dodajete klikom na jednu od vrsta na popisu.',
        'email_to_which_notifications_will_be_sent': 'E-pošta na koju će biti poslana obavijest',
        'checkout_methods': 'Načini plaćanja i dostave',
        'checkout_methods_info': 'Kupcu se ponude samo aktivni načini s imenom, u redoslijedu koji je postavljen ovdje. Način bez imena se ne sprema.',
        'shipping_methods': 'Načini dostave',
        'shipping_price': 'Cijena',
        'shipping_price_info': 'Cijena se obračunava kada je košarica teža od svih donjih ograničenja težine.',
        'max_weight': 'Do težine',
        'add_weight_price': 'Dodaj cijenu po težini',
        'payment_method_type': {
            'credit_card': 'Plaćanje karticom',
            'bank_transfer': 'Plaćanje putem računa',
            'cash_on_delivery': 'Plaćanje pouzećem'
        },
        'shipping_method_type': {
            'local_pickup': 'Osobno preuzimanje',
            'slovenian_post': 'Pošta Slovenije',
            'intereuropa': 'Intereuropa'
        },
        'component_type': {
            'image_slider': 'Klizač slik',
            'item_slider': 'Klizač stavk',
            'gallery': 'Galerija',
            'hero': 'Hero',
            'specification': 'Specifikacije',
            'banner': 'Baner',
            'text_content': 'Tekst',
            'partner_slider': 'Klizač partnera',
            'card_slider': 'Klizač kartice',
            'showcase_items': 'Istaknute kartice',
            'newsletter_subscription': 'Prijava no novine',
            'contact_form': 'Obrazac za kontakt',
            'button': 'Gumb'
        }
    },
    'product_brand': {
        'product_brand': 'Marka | Marke',
        'add': 'Dodaj marko',
        'edit': 'Uredi marko',
        'importer': 'Uvoznik | Uvoznici',
        'add_importer': 'Dodaj uvoznika',
        'edit_importer': 'Uredi uvoznika',
        'service': 'Servis | Servisi',
        'add_service': 'Dodaj servis',
        'edit_service': 'Uredi servis',
        'disclaimer': 'Upozorenje | Upozorenja',
        'add_disclaimer': 'Dodaj upozorenje',
        'warranty_hint': 'Vrijedi za sve proizvode ove marke koji nemaju vlastitu garanciju.',
        'edit_disclaimer': 'Uredi upozorenje',
        'website': 'Web stranica'
    },
    'category': {
        'category': 'Kategorija | Kategorije',
        'add_new': 'Dodaj novo',
        'delete_info': 'Ovo će izbrisati i sve potkategorije!',
        'not_all_fields_filled_info': 'Nisu popunjena sva polja',
        'search': 'Traži po kategorijah',
        'ignored_categories_on_user_page': 'Ignorirane kategorije na korisničkoj stranici',
        'choose_your_source_category': 'Odaberite kategoriju izvora'
    },
    'product': {
        'product': 'Produkt | Produkti',
        'synced_product': 'Sinkronizirani produkt | Sinkronizirani produkti',
        'add': 'Dodaj produkt',
        'edit': 'Uredi produkt',
        'id': 'ID produkta',
        'sku': 'SKU',
        'ean': 'EAN',
        'stock': 'Zaloga',
        'title': 'Naslov',
        'pretext': 'Predtekst',
        'description': 'Opis',
        'short_description': 'Kratak opis',
        'price': 'Cijena',
        'regular_price': 'Redovna cijena',
        'price_without_vat': 'Cijena bez PDV-a',
        'price_with_vat': 'Cijena s PDV-om',
        'discount': 'Popust',
        'main_image': 'Glavna slika',
        'additional_images': 'Dodatne slike',
        'status': 'Status',
        'draft': 'Skica',
        'publish': 'Objavi',
        'preview': 'Predogled',
        'unpublish': 'Poništi objavu',
        'published': 'Objavljeno',
        'unpublished': 'Nije objavljeno',
        'imported': 'Uvozeno',
        'disabled': 'Onemogućeno',
        'disable': 'Onemogući',
        'enable': 'Omogući',
        'show_disabled': 'Prikaži onemogućene',
        'videos': 'Videozapisi',
        'cta': 'CTA (Poziv na akciju)',
        'primary_features': 'Primarne značajke',
        'main_features': 'Glavne značajke',
        'video_features': 'Video značajke',
        'secondary_features': 'Sekundarne značajke',
        'product_features': 'Značajke produkta',
        'hero_banner': 'Hero sekcija',
        'tertiary_features': 'Tercijarne značajke',
        'specifications': 'Specifikacije',
        'additional_specifications': 'Dodatne specifikacije',
        'attachment': 'Priloz',
        'attachments': 'Prilozi',
        'disclaimer': 'Izjava o odricanju odgovornosti',
        'section_title': 'Naslov sekcije',
        'url': 'URL',
        'shipping': {
            'shipping': 'Dostava',
            'weight': 'Težina',
            'gross_weight': 'Bruto težina',
            'length': 'Duljina',
            'width': 'Širina',
            'height': 'Visina'
        },
        'specification': {
            'type': 'Tip specifikacije',
            'add_new_specification_type': 'Dodaj nov tip specifikacije',
            'missing_specifications': 'Nedostaju specifikacije',
            'from_categories': 'Iz odabranih kategorija',
            'from_categories_hint': 'Ove specifikacije dodane su automatski na temelju odabranih kategorija proizvoda.',
            'from_selected_template': 'Iz odabrane predloge',
            'from_selected_template_hint': 'Ove specifikacije dodane su iz predloge odabrane u padajućem popisu iznad.',
            'template_already_from_category': 'Predloga "{names}" već je dodana automatski na temelju odabranih kategorija, pa će njezine specifikacije biti prikazane dva puta. Ako vam ne treba posebno, očistite je u padajućem popisu.',
            'section_source': 'Predloga: {name}'
        },
        'section': {
            'basic_information': 'Osnovne informacije',
            'billing_information': 'Podaci za naplatu',
            'media': 'Mediji',
            'features': 'Značajke',
            'specifications': 'Specifikacije',
            'attachments': 'Prilozi',
            'disclaimer': 'Izjava o odricanju odgovornosti'
        },
        'add_new_value': 'Dodaj novo vrijednost',
        'fill_from_another_locale': 'Popuni iz druge lokalizacije',
        'fill_from_another_locale_info': 'Vaš trenutačni sadržaj bit će izbrisan i popunjen sadržajem odabrane lokalizacije.',
        'fill_content': 'Popuni sadržaj',
        'in_use': {
            'category': 'Proizvodi na kojima se koristi kategorija',
            'product_brand': 'Proizvodi na kojima se koristi marka',
            'product_specification': 'Proizvodi na kojima se koristi specifikacija proizvoda',
            'sale_website': 'Proizvodi na kojima se koristi web stranica',
            'vat_group': 'Proizvodi na kojima se koristi PDV grupa'
        },
        'use_open_ai': 'Koristi OpenAI za prijevod',
        'export': 'Izvoz',
        'stocks': 'Zalihe',
        'prices': 'Cijene',
        'product_not_synced': 'Produkt nije sinkroniziran s ISelect-om',
        'warranty': 'Garancija',
        'warranty_unit': 'Jedinica garancije',
        'warranty_from_brand': 'marka',
        'warranty_brand_hint': 'Ako ostane prazno, vrijedi garancija marke: {warranty}',
        'warranty_units': {
            'month': 'Mjeseci',
            'year': 'Godine'
        },
        'warranty_unit_forms': {
            'month': {
                'one': 'mjesec',
                'few': 'mjeseca',
                'other': 'mjeseci'
            },
            'year': {
                'one': 'godina',
                'few': 'godine',
                'other': 'godina'
            }
        },
        'export_excel': 'Izvoz u Excel',
        'import_excel': 'Uvoz iz Excela',
        'import_excel_result': 'Rezultat uvoza iz Excela',
        'import_excel_created': 'Kreirani proizvodi',
        'import_excel_updated': 'Ažurirani proizvodi',
        'import_excel_specifications_updated': 'Ažurirane specifikacije',
        'import_excel_errors': 'Greške',
        'import_excel_row': 'Redak',
        'import_excel_success': 'Uvoz iz Excela je uspio',
        'import_excel_partial_success': 'Uvoz iz Excela je djelomično uspio, provjerite greške'
    },
    'configuration': {
        'country_configuration': 'Konfiguracija zemlje | Konfiguracije zemlja',
        'currency': 'Valuta',
        'petrol_categories_mapping': 'Mapiranje Petrol kategorija',
        'petrol_category': 'Petrol kategorija',
        'petrol_category_code': 'Šifra',
        'add_petrol_category': 'Dodaj Petrol kategoriju',
        'edit_petrol_category': 'Uredi Petrol kategoriju',
        'petrol_category_exists': 'Petrol kategorija sa šifrom {code} već postoji',
        'petrol_category_missing_name': 'Nedostaje naziv',
        'petrol_category_missing_name_error': 'Petrol kategorije bez šifre ili naziva: {codes}. Dopunite ih i ponovno spremite.',
        'delete_petrol_category_in_use': 'Na Petrol kategoriju {code} {name} mapirano je kategorija: {count}. Nakon spremanja proizvodi iz njih bit će u izvozu za Petrol bez klasifikacije. Želite li je stvarno izbrisati?'
    },
    'additional_page': {
        'additional_page': 'Dodatna stranica | Dodatne stranice',
        'add': 'Dodaj dodatnu stranicu',
        'edit': 'Uredi dodatnu stranicu',
        'save': 'Shrani dodatnu stranicu',
        'for': 'Dodatna stranica za {name}',
        'add_in_other_language': 'Dodaj na drugom jeziku',
        'add_in_other_language_info': 'Na odabranom jeziku bit će dodana nova stranica s kopiranim sadržajem ove stranice.',
        'exists_in_all_languages': 'Stranica postoji na svim jezicima ove prodajne stranice',
        'new_page': 'Nova stranica',
        'copied_from_page': 'Podaci su kopirani sa stranice "{name}". Odaberite državu i spremanje će stvoriti novu stranicu.'
    },
    'sale_partner': {
        'sale_partner': 'Partner za prodaju | Partneri za prodaju',
        'add': 'Dodaj partnera za prodaju',
        'edit': 'Uredi partnera za prodaju',
        'partner_key': 'Ključ partnera',
        'product_export_type': 'Vrsta izvoza proizvoda',
        'empty_price_list': 'Cjenik je prazan za odabranog partnera.',
        'prices': 'Cjenik',
        'product_key': 'Šifra proizvoda',
        'price_list_name': 'Naziv cjenika',
        'price_list_code': 'Šifra cjenika',
        'validity': 'Valjanost',
        'last_updated': 'Zadnje ažuriranje'
    },
    'order': {
        'order': 'Narudžba | Narudžbe',
        'show_order': 'Prikaži narudžbu',
        'order_number': 'Broj narudžbe',
        'copy_order_number': 'Kopiraj broj narudžbe',
        'order_date': 'Datum narudžbe',
        'total': 'Ukupno',
        'order_status': 'Status narudžbe',
        'payment_status': 'Status plaćanja',
        'order_success': 'Narudžba uspješna',
        'order_failed': 'Narudžba nije uspjela',
        'customer': 'Kupac',
        'created': 'Kreirano',
        'quantity': 'Količina',
        'subtotal': 'Međuzbroj',
        'phone': 'Telefon',
        'billing_address': 'Adresa za naplatu',
        'shipping_address': 'Adresa za dostavu',
        'same_as_billing_address': 'Isto kao adresa za naplatu',
        'payment': 'Plaćanje',
        'order_history': 'Povijest narudžbe',
        'items_in_order': 'Stavke u narudžbi',
        'transaction_id': 'ID transakcije',
        'message': 'Sporočilo',
        'status': {
            'pending': 'Naručeno',
            'processing': 'U obradi',
            'shipped': 'Otpremljeno',
            'ready_for_pickup': 'Spremno za preuzimanje',
            'completed': 'Završeno',
            'not_picked_up': 'Završeno / nepreuzeto',
            'cancelled': 'Otkazano'
        },
        'status_payment': {
            'pending': 'Na čekanju',
            'paid': 'Plaćeno',
            'failed': 'Neuspješno',
            'refunded': 'Vračilo'
        }
    },
    'upit': {
        'upit': 'Upit | Upiti',
        'show_inquiry': 'Prikaži upit',
        'empty': 'Trenutno nemate aktivnih upita.',
        'terms_1': 'Slanjem upita pristajem na',
        'add_to_inquiry': 'Dodaj u upit',
        'proceed_to_offer': 'Nastavi s ponudom',
        'preparation_of_offer': 'Priprema ponude',
        'success_add_to_inquiry': 'Proizvod uspješno dodan u upit!',
        'go_to_inquiry_overview': 'Nastavi s pregledom upita',
        'send_inquiry': 'Pošalji upit',
        'address': 'Adresa',
        'inquiry_success': 'Upit uspješno poslan',
        'inquiry_failed': 'Upit nije uspio',
        'inquiry_number': 'Broj inquiry',
        'date_of_sent_inquiry': 'Datum poslanog upita',
        'inquiry_status': 'Status upita',
        'inquiry_history': 'Povijest upita',
        'items_in_inquiry': 'Stavke u upitu',
        'status': {
            'pending': 'Poslano',
            'processing': 'U obradi',
            'completed': 'Završeno',
            'cancelled': 'Otkazano'
        }
    },
    'theme': {
        'light': 'Svijetla tema',
        'dark': 'Tamna tema',
        'auto': 'Automatski (prema sustavu)'
    },
    'template': {
        'specification_template': 'Predloga specifikacij | Predloge specifikacij',
        'categories_changed_warning': 'Promijenili ste kategorije ove predloge. Promjena utječe na postojeće proizvode.',
        'categories_removed': 'Uklonjene kategorije: {names}',
        'categories_removed_effect': 'Proizvodi u tim kategorijama izgubit će sekcije specifikacija iz ove predloge, uključujući već unesene vrijednosti. Br. zahvaćenih proizvoda: {count}',
        'categories_added': 'Dodane kategorije: {names}',
        'categories_added_effect': 'Proizvodi u tim kategorijama automatski će dobiti sekcije specifikacija iz ove predloge, s praznim vrijednostima. Br. zahvaćenih proizvoda: {count}',
        'categories_changed_hint': 'Na pojedinom proizvodu promjena se primjenjuje kada ga sljedeći put otvorite u uređivanju i spremite.'
    },
    'sync_status': {
        'sync_status': 'Status sinkronizacije | Statusi sinkronizacije',
        'running': 'U tijeku',
        'started_at': 'Započeto',
        'last_finished_at': 'Zadnje završeno',
        'refresh': 'Osvježi',
        'force_sync_ishop_data': 'Sinkroniziraj podatke iz iShopa',
        'force_sync_sale_partner_price_lists': 'Sinkroniziraj cjenike partnera',
        'sync_started': 'Sinkronizacija je pokrenuta i izvodi se u pozadini',
        'sync_already_running': 'Sinkronizacija je već u tijeku',
        'names': {
            'sync_ishop_product_data': 'Sinkronizacija podataka o proizvodima',
            'sync_ishop_product_stock': 'Sinkronizacija zaliha',
            'sync_data_with_fts': 'Sinkronizacija tražilice',
            'sync_ishop_sale_partner_price_list': 'Sinkronizacija cjenika partnera'
        }
    }
}
